module.exports = __webpack_public_path__ + "static/media/7-EntregasVerificadasconReniec.341d9cc4.jpg";